/** Типи системних подій (backend SystemEvent type) з кольорами бейджів */
export const SYSTEM_EVENT_TYPE_OPTIONS = [
    { value: 'successful_authorization', label: 'Успішна авторизація', color: '#52c41a' },
    { value: 'authorization_error', label: 'Помилка авторизації', color: '#ff4d4f' },
    { value: 'user_invitation', label: 'Запрошення користувача', color: '#4a9eff' },
    { value: 'user_reinvitation', label: 'Повторне запрошення', color: '#13c2c2' },
    { value: 'user_creation', label: 'Створення користувача', color: '#9254de' },
    { value: 'changing_user_role', label: 'Зміна ролі', color: '#d4b106' },
]
